<template>
  <v-container>
    <v-row>
      <v-col cols="6" xl="3" lg="6" md="12" v-for="post in posts" :key="post.id">
        <PostCard :post="post"></PostCard>
      </v-col>
    </v-row>
    <Over18Diag></Over18Diag>
  </v-container>
</template>

<script>
import Over18Diag from "@/components/common/Over18Diag";
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import PostCard from "@/components/repost_feed/PostCard";
const PostRepo = RepositoryFactory.get('post')
export default {
  name: "ImagePostFeed",
  components: {PostCard, Over18Diag},
  data: () => ({
    posts: Array[Object],
    hasNotAccepted18Plus: true,
    backgroundPoll: null,
    seenIds: []
  }),
  methods: {
    getPostHistory(limit, offset) {
      return PostRepo.getSleuthPost({limit: limit, offset: offset}, true)
          .then(res => {
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
            }
            return res;
          })
    },
    refreshList() {
      if (this.seenIds.length > 200) {
        this.seenIds = [];
      }
      this.getPostHistory(20, null)
          .then(res => {
            if (res.status === 'error') {
              return;
            }
            res.data.forEach(post => {
              if (!this.posts.some(r => r.post_id === post.post_id)) {
                if (!this.seenIds.includes(post.post_id)) {
                  this.posts.unshift(post);
                  this.posts.splice(this.posts.length - 1, 1)
                  this.seenIds.push(post.post_id)
                }

              }
            })
          })
    },

  },
  mounted() {
    this.getPostHistory(20, null)
        .then(res => {
          if (res.status === 'success')
            this.posts = res.data;
          this.backgroundPoll = setInterval(() => {
            this.refreshList()
          }, 5000)
        })
  },
  beforeDestroy() {
    clearInterval(this.backgroundPoll);
  },
}
</script>

<style scoped>

</style>